import { useKnockFeed as i } from "@knocklabs/react-core";
import o from "react";
import { BellIcon as c } from "../../../core/components/Icons/Bell.mjs";
import { UnseenBadge as a } from "../UnseenBadge/UnseenBadge.mjs";
/* empty css            */
const d = o.forwardRef(({
  onClick: t,
  badgeCountType: e
}, n) => {
  const {
    colorMode: r
  } = i();
  return /* @__PURE__ */ o.createElement("button", { className: `rnf-notification-icon-button rnf-notification-icon-button--${r}`, role: "button", "aria-label": "Open notification feed", ref: n, onClick: t }, /* @__PURE__ */ o.createElement(c, null), /* @__PURE__ */ o.createElement(a, { badgeCountType: e }));
});
export {
  d as NotificationIconButton
};
//# sourceMappingURL=NotificationIconButton.mjs.map
